export default "__VITE_ASSET__ePOaLjun__"